import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Table } from "antd";
import React, { memo, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { getCurrencyList } from "../../../../store/actions/currency";
import { clearUsedGoods, getUsedGoods } from "../../../../store/actions/usedGoods";
import EmptyState from "../../../vapor/emptyState";
import UsedGoodsDrawer from "./drawer";
import "./style.scss";

const UsedGoods = ({currency, draftId}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const jsonCurrency = useSelector(state => state?.currencyList?.currencies);
  const isGettingList = useSelector(state => state.precog.usedGoods.status.started);
  const isError = useSelector(state => state.precog.usedGoods.status.error);
  const usedGoodsList = useSelector(state => state.precog.usedGoods?.list);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerId, setDrawerId] = useState(null);

  useEffect(() => {
    if (!jsonCurrency) 
      dispatch(getCurrencyList());  
      
  }, []);

  useEffect(() => {
    /** for the used goods tab I have to make the call first to know 
     * whether to view it or not */
    dispatch(getUsedGoods(draftId)).then(() => {

    }).catch(e => {
      console.log(e);
    });
    return () => {
      dispatch(clearUsedGoods());
    };
  }, [draftId]);

  const columnsGoods = [
    {
      title: intl.formatMessage({ id: "preCog.usedGoods.articles" }),
      dataIndex: "articleDesc",
      width: "calc(40% - 50px)"          
    },    
    {
      title: intl.formatMessage({ id: "preCog.usedGoods.quantity" }),
      dataIndex: "quantity",
      width: "15%"          
    },
    {
      title: intl.formatMessage({ id: "preCog.usedGoods.total" }),
      dataIndex: "amount",
      width: "15%",
      render: value => <div style={{fontWeight: "bold"}}>
        {value} {jsonCurrency?.[currency || "EUR"]?.symbol || "€"}
      </div>            
    },
    {
      title: "",
      dataIndex: "",
      width: "50px",
      render: (
        text, record, index
      ) => <div style={{cursor: "pointer"}}
        onClick={() => {          
          if (record.id !== drawerId){
            setIsDrawerOpen(true);             
            setDrawerId(record.id);
          }
        }
        }
      >
        <FontAwesomeIcon icon={["far", "external-link-square-alt"]} style={{color: "#0090d1"}} />
      </div>   
    }
  ];

  return isGettingList ? 
    <div style={{display: "flex", justifyContent: "center"}}>
      <FontAwesomeIcon icon={["far", "spinner"]} style={{
        color: "#0090d1",
        fontSize: "44px",
        cursor: "pointer",
        marginBottom: isError ? "20px" : 0
      }} spin /> 
    </div>
    :    
    <>
      <Table  
        locale={{ emptyText: <EmptyState withIcon={true} /> }} 
        columns={columnsGoods} dataSource={usedGoodsList} 
        pagination={false} />       
      <UsedGoodsDrawer draftId={draftId} goodsId={drawerId} 
        currency={jsonCurrency?.[currency || "EUR"]?.symbol || "€"} 
        onClose={() => {setIsDrawerOpen(false); setDrawerId(null);}} visible={isDrawerOpen} />
    </>
  ;
  
};

export default memo(UsedGoods);